export default __webpack_public_path__ + "static/media/866.aacdb5b1.png";